import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	usePurchaseItemForms,
	useMerchandiseItem
} from '../../hooks'
import {
	deleteMerchandiseItem,
	editMerchandiseItem,
	updateItemCartQty,
	setPurchaser,
	setEditor
} from '../merchandiseSlice'
import useApiStatusDispatch from '../../../../hooks/useApiStatusDispatch'
import useCurrentUser from '../../../../hooks/useCurrentUser'
import styles from './Item.module.css'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import InputGroup from 'react-bootstrap/InputGroup'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'
import {selectAcceptedCurrency} from '../../../settings/settingsSlice'
import {getCurrencySymbol} from '../../../../util/intl'
import DiscussResourceButton from '../../../DiscussResourceButton/DiscussResourceButton'

const Item = ({id})=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const {item} = useMerchandiseItem(id)
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const user = useCurrentUser()

	const {
		status:itemFormsStatus,
		forms:itemForms
	} = usePurchaseItemForms('merchandise',id)

	const [qty,setQty] = useState(1)

	const handleToggleEditor = () => { 
		dispatch( setEditor({show:true,id}) ) 
	}
	const handleDelete = ()=>{
		if(!window.confirm(`Are you sure you want to delete ${item.title}?`)) return
		statusDispatch(deleteMerchandiseItem(id),'merchandise item','delete')
	}
	const handleActivation = ()=>{
		dispatch(editMerchandiseItem({
			update:{active:item.active^1},
			id
		}))
	}

	const handleAddToCart = ()=>{
		dispatch(updateItemCartQty({id,qty}))
	}


	const handleSetQty = e => {
		const val = Math.max(1,e.target.value)
		setQty(val)
	}

	return (
		<div className={styles.Item}>
			<header>
				<strong style={{paddingBottom:'4px',borderBottom:'1px solid #00ff8c'}}>
					{Boolean(item.title)?item.title:'Title not set'}
				</strong>
				<span className="ml-auto">
					{getCurrencySymbol(acceptedCurrency.ISO)}{parseFloat((item.unit_amount/100).toFixed(2))} ({acceptedCurrency.ISO})
				</span>
			</header>
			{user.account_type !== 'client'&&
				<div className="text-right">
					<small tabIndex={0} onClick={handleActivation} style={{cursor:'pointer'}}>
						<Badge variant={item.active?'success':'danger'}>
							{item.active?'Active':'NOT Active'}
						</Badge>
					</small>
				</div>
			}
			<div className="d-flex">
				{Boolean(item.attachment)&&
					<img 
						style={{
							borderRadius:'7px',
							maxHeight:'200px',
							objectFit:'cover',
							marginRight:'8px',
							width:'120px',
						}} 
						src={item.attachment}
					/>
				}
				<div>
					<div>
						{item.description}
					</div>
				</div>
			</div>
			<div>
				<small>
					Forms: {
						itemFormsStatus==='idle'
						//if forms are loaded
						? (
							itemForms.length > 0
							? itemForms.map(
								f => f.form_title
							).join(', ')
							: 'No forms/waivers attached to this product'
						)
						//forms still loading
						: 'Loading forms...'
					}
				</small>
			</div>
			{
				user.account_type !== 'client' ?
				<div className="d-flex justify-content-between mt-auto">
					<Button 
						onClick={handleDelete}
						className="text-danger"
						variant="link" 
						size="sm"
					>
						Delete
					</Button>
					<OverlayTrigger overlay={
						<Tooltip>Discuss this product in the chat</Tooltip>
					}>
						<span className="ml-auto">
							<DiscussResourceButton
								className="btn btn-sm btn-link text-info"
								name={item.name}
								id={item.id}
								type="merchandise_item"
							>
								Discuss
							</DiscussResourceButton>
						</span>
					</OverlayTrigger>
					<Button 
						onClick={handleToggleEditor}
						className="text-primary"
						variant="link" 
						size="sm"
					>
						Edit
					</Button>
				</div>
				:
				<div className="text-right mt-auto">
					<OverlayTrigger overlay={
						<Tooltip>Discuss this product in the chat</Tooltip>
					}>
						<span className="ml-auto">
							<DiscussResourceButton
								className="btn btn-sm btn-link text-info"
								name={item.name}
								id={item.id}
								type="merchandise_item"
							>
								Discuss
							</DiscussResourceButton>
						</span>
					</OverlayTrigger>
					<InputGroup>
						<Form.Control 
							onFocus={e=>{e.target.select()}}
							onChange={handleSetQty}
							placeholder="qty"
							type="number"
							value={qty}
							size="sm"
						/>
						<InputGroup.Append>
							<Button 
								variant="outline-primary"
								onClick={handleAddToCart} 
								size="sm"
							>
								Add to Cart
							</Button>
						</InputGroup.Append>
					</InputGroup>
				</div>
			}
		</div>
	)
}

export default Item